import i18next from 'i18next';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { putEntities } from '@wix/da-shared-react/pkg/redux/entities/actions';
import { CommissionStatusCodeMap } from '@wix/da-shared-react/pkg/types/commissions';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { addErrorNotification } from '@wix/da-shared-react/pkg/Notifications/redux/actionCreators';
import { changeAllCommissionsStatus } from '../../actions/studio/products';
import { STUDIO_DEVIATIONS_STREAM } from '../../../constants';

function* handleChangeAllCommissionsStatus({
  payload: { status },
}: ReturnType<typeof changeAllCommissionsStatus>) {
  const response = yield call(
    requestPuppy,
    {
      method: 'post',
      url: '/module/commissions/change_all_commissions_status',
      data: { status },
    },
    undefined,
    'gruser'
  );

  if (!response || isApiError(response) || !response.success) {
    yield put(addErrorNotification(i18next.t('common.somethingWentWrong')));
    return;
  }

  const { streamId } = STUDIO_DEVIATIONS_STREAM;
  const commissionsIds = yield select(streamSelectors.getItems, streamId);
  const commissions = yield select(getDeviationsByIds, commissionsIds);
  const updatedCommissions = commissions.map(deviation => {
    deviation.commission.status = CommissionStatusCodeMap[response.data.status];
    return deviation;
  });

  const { entities } = normalize(updatedCommissions, deviationSchema);
  yield put(putEntities({ entities }));
}

export default function* saga() {
  yield all([takeLatest(changeAllCommissionsStatus, handleChangeAllCommissionsStatus)]);
}
